import api from '../api'

const state = {
  all: [],
  asset: null,
  footageLoadingVal: null
}

const actions = {
  getAssets: ({ state, commit }, id) => {
    return api.getAllAssets(id).then(assets => {
      return commit('setAllAssets', assets)
    })
  },
  getImageAssets: ({ state, commit }, id) => {
    return api.getAllImageAssets(id).then(assets => {
      return commit('setAllAssets', assets)
    })
  },
  getVideoAssets: ({ state, commit }, id) => {
    return api.getAllVideoAssets(id).then(assets => {
      return commit('setAllAssets', assets)
    })
  },
  uploadAssets: ({ state, commit }, id) => {
    return api.uploadAssetsToCreative(id)
  },
  deleteAsset: ({ state, commit }, id) => {
    return api.deleteSingleAsset(id)
  },
  uploadFootage: ({ state, commit }, id) => {
    return api.uploadFootage(id, commit, state)
  },
  deleteFootage: ({ state, commit }, id) => {
    return api.deleteFootage(id, commit, state)
  }
}

const mutations = {
  setAllAssets (state, assets) {
    state.all = assets
  }
}

const getters = {
  all: state => {
    return state.all
  },
  asset: state => {
    return state.asset
  },
  footageLoadingVal: state => {
    return state.footageLoadingVal
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/assets.js